var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.5403 0.121094H6.45968C2.51536 0.121094 0.16394 2.47251 0.16394 6.41683V15.4974C0.16394 19.4417 2.51536 21.7932 6.45968 21.7932H15.5403C19.4846 21.7932 21.836 19.4417 21.836 15.4974V6.41683C21.836 2.47251 19.4846 0.121094 15.5403 0.121094Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8375 7.56539C17.8375 8.00967 17.4799 8.37809 17.0248 8.37809H11.3359C10.8916 8.37809 10.5232 8.00967 10.5232 7.56539C10.5232 7.12111 10.8916 6.75269 11.3359 6.75269H17.0248C17.4799 6.75269 17.8375 7.12111 17.8375 7.56539Z",
    fill: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80022 6.51443L6.36212 8.95254C6.19958 9.11508 5.99369 9.19093 5.78781 9.19093C5.58192 9.19093 5.3652 9.11508 5.2135 8.95254L4.40079 8.13984C4.07571 7.82559 4.07571 7.30546 4.40079 6.99122C4.71504 6.67697 5.22433 6.67697 5.54941 6.99122L5.78781 7.22961L7.6516 5.36581C7.96585 5.05157 8.47514 5.05157 8.80022 5.36581C9.11447 5.68006 9.11447 6.20019 8.80022 6.51443Z",
    fill: "#007AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8375 15.1506C17.8375 15.5949 17.4799 15.9633 17.0248 15.9633H11.3359C10.8916 15.9633 10.5232 15.5949 10.5232 15.1506C10.5232 14.7063 10.8916 14.3379 11.3359 14.3379H17.0248C17.4799 14.3379 17.8375 14.7063 17.8375 15.1506Z",
    fill: "#007AFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80022 14.0996L6.36212 16.5377C6.19958 16.7003 5.99369 16.7761 5.78781 16.7761C5.58192 16.7761 5.3652 16.7003 5.2135 16.5377L4.40079 15.725C4.07571 15.4108 4.07571 14.8907 4.40079 14.5764C4.71504 14.2622 5.22433 14.2622 5.54941 14.5764L5.78781 14.8148L7.6516 12.951C7.96585 12.6368 8.47514 12.6368 8.80022 12.951C9.11447 13.2653 9.11447 13.7854 8.80022 14.0996Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActive);
export default __webpack_public_path__ + "static/media/list-active.c4c55e4a76396029d1fedc9d539f4a04.svg";
export { ForwardRef as ReactComponent };